import { StringHelper } from "../../utilities/contracts/string-helper";
import { StorageValueHelper } from "./storage-value-helper.model";
import * as i0 from "@angular/core";
export class LocalService {
    put(key, value) {
        StringHelper.throwIsAvailableError(key, "key");
        const stringValue = StorageValueHelper.create(value);
        window.localStorage.setItem(key, stringValue);
    }
    get(key, defaultValue) {
        StringHelper.throwIsAvailableError(key, "key");
        const value = window.localStorage.getItem(key);
        const realValue = StringHelper.isAvailable(value) ? StorageValueHelper.get(value) : defaultValue;
        return realValue;
    }
    delete(key = "") {
        window.localStorage.removeItem(key);
    }
    clear() {
        window.localStorage.clear();
    }
}
LocalService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LocalService_Factory() { return new LocalService(); }, token: LocalService, providedIn: "root" });
